<template>
    <a class="back" @click="handleClick">
        <i :class="icon || 'icon icon-arrow'"/>
        <span v-if="text">{{text}}</span>
    </a>
</template>

<script>
export default {
    name: 'Back',
    props: ['text', 'url', 'icon', 'fixed', 'backFunc'],

    components: {
    },

    methods: {
        handleClick () {
            const source = this.$route?.meta?.source || this.$route?.query?.source || ''
            if (this.backFunc) {
                return this.backFunc()
            }
            if (this.url) {
                this.location.replace(this.url)
            } else if (history.length > 1) {
                this.location.back()
            } else {
                source === 'cac' ? this.location.push('/cac') : this.location.push(`/quiz/${source}`)
            }
        }
    }
};
</script>
<style lang="less" scoped>
.back {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3rem;
    height: 3rem;
    position: absolute;
    left: 1.3rem;
    top: 1.2rem;
    border: 0;
    font-size: 2.3rem;
    color: #fff;
    >*{
        display: block;
    }
    /deep/ .icon {
        font-size: 2.3rem;
    }
}
</style>